import { RESERVED_SHOP_SLUGS } from '~/utils/reservedShopSlugs'

/** Top-level storefront segments that are real routes (not CMS page slugs).
 *  App routes like `/vinde` and `/retur` must stay in RESERVED_SHOP_SLUGS
 *  so they are not rewritten to `/cms/{slug}`. */
const STOREFRONT_ROOT_SEGMENTS = new Set([
  ...RESERVED_SHOP_SLUGS,
  'platform',
])

/**
 * Normalize a configured storefront link:
 * - strip same-origin absolute URLs to pathname
 * - map legacy `/slug` CMS pages to `/cms/slug`
 */
export function normalizeStorefrontPath(path: string, siteOrigin = ''): string {
  if (!path) return '/'

  let raw = path.trim()
  if (!raw) return '/'

  if (/^(mailto:|tel:|\/\/)/i.test(raw)) {
    return raw
  }

  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw)
      const origin = siteOrigin.replace(/\/$/, '')
      if (origin && url.origin === origin) {
        raw = `${url.pathname}${url.search}${url.hash}` || '/'
      } else {
        return raw
      }
    } catch {
      return raw
    }
  }

  const queryHashMatch = raw.match(/[?#].*$/)
  const suffix = queryHashMatch?.[0] || ''
  let pathname = suffix ? raw.slice(0, raw.length - suffix.length) : raw
  if (!pathname.startsWith('/')) pathname = `/${pathname}`

  const segments = pathname.split('/').filter(Boolean)
  if (segments.length === 1) {
    const only = segments[0]!.toLowerCase()
    if (!STOREFRONT_ROOT_SEGMENTS.has(only)) {
      pathname = `/cms/${only}`
    }
  }

  return `${pathname}${suffix}`
}
